import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled'
import classNames from 'classnames';
import { useIntl } from 'gatsby-plugin-intl';

import EnLogoDark from './logo-thewitcher-dark-en@1x.png'
import EnLogoDark2x from './logo-thewitcher-dark-en@2x.png'
import EnLogoWhite from './logo-thewitcher-light-en@1x.png'
import EnLogoWhite2x from './logo-thewitcher-light-en@2x.png'
import PlLogoDark from './logo-thewitcher-dark-pl@1x.png'
import PlLogoDark2x from './logo-thewitcher-dark-pl@2x.png'
import PlLogoWhite from './logo-thewitcher-light-pl@1x.png'
import PlLogoWhite2x from './logo-thewitcher-light-pl@2x.png'

const Image = styled.img`
  &.white {
    filter: drop-shadow(0px 1px 6px rgba(0, 0, 0, 0.8)) drop-shadow(0px 2px 16px #000000);
  }
`

export const Logo = ({ white, ...props }) => {

  const {locale} = useIntl();

  const logoDark = locale == 'pl' ? PlLogoDark : EnLogoDark;
  const logoDark2x = locale == 'pl' ? PlLogoDark2x : EnLogoDark2x;
  const logoWhite = locale == 'pl' ? PlLogoWhite : EnLogoWhite;
  const logoWhite2x = locale == 'pl' ? PlLogoWhite2x : EnLogoWhite2x;

  const [logo, setLogo] = useState(logoDark)
  const [logo2x, setLogo2x] = useState(logoDark2x)

  useEffect(() => {
    setLogo(white ? logoWhite : logoDark)
    setLogo2x(white ? logoWhite2x : logoDark2x)
  }, [white])

  return logo && logo2x && <Image src={logo} srcSet={`${logo} 320w, ${logo2x} 640w`} className={classNames({ white })} {...props} />
}

export default Logo;


